/**
 * Fixture rows are keyed off a fixed set of client ids (`client-1` … `client-4`),
 * but real backend stores have opaque ids (numeric `"1"`, `"2"`, … or generated
 * `client-mock-<timestamp>` demo stores) that don't match. Without a fallback
 * every analytics tab on a real store comes up empty.
 *
 * `aliasClient` returns the requested id if any fixture row already matches it,
 * otherwise it falls back to a default demo client so the page is never blank —
 * but only for those opaque, non-fixture-shaped ids. An id that already looks
 * like a fixture key (`client-<n>`) is an explicit, scoped tenant identifier:
 * if it's not one of the fixture's own ids, that tenant genuinely has no mock
 * data and must resolve to empty rather than silently leaking another
 * tenant's (client-1's) data across the scoping boundary — see
 * `__tests__/scoping.test.ts`.
 *
 * When the analytics mocks are eventually replaced by API adapters, this
 * helper goes with them.
 */
const DEFAULT_DEMO_CLIENT = 'client-1'
const FIXTURE_SHAPED_ID = /^client-\d+$/

export function aliasClient<T extends { clientId: string }>(
  clientId: string,
  rows: readonly T[],
): string {
  if (rows.some((r) => r.clientId === clientId)) return clientId
  if (FIXTURE_SHAPED_ID.test(clientId)) return clientId
  return DEFAULT_DEMO_CLIENT
}
